import { Theme } from "@remo-co/ui-core/src/types";

export const styles = {
  dialogTextSpaceBtwn: {
    paddingTop: "20px",
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    color: "black",
    ".MuiFormControlLabel-root": {
      marginLeft: 0,
    },
  },
  checkbox: {
    width: 20,
    height: 20,
    display: "flex",
    backgroundColor: (theme: Theme) => theme.palette.events.whiteTertiary,
    borderRadius: "4px",
    border: "1px solid",
    borderColor: (theme: Theme) => theme.palette.events.grayTertiary,
  },
  checkboxIcon: {
    width: 22,
    height: 22,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: "4px",
    backgroundColor: (theme: Theme) => theme.palette.events.blueSecondary,
  },
  actionBtn: {
    backgroundColor: "events.dialogHeaderBackground",
    padding: "0px 15px 40px 15px",
  },
};
